import { Loader2, ScanLine } from "lucide-react";
import { useExtraction } from "@/context/ExtractionContext";

// Indicatore fisso: mostra le letture AI in corso anche se si cambia pagina.
export default function ExtractionIndicator() {
  const { jobs } = useExtraction();
  const running = jobs.filter((j) => j.stato === "in_corso");
  const ready = jobs.filter((j) => j.stato === "completo");
  if (running.length === 0 && ready.length === 0) return null;
  const fatti = running.reduce((s, j) => s + (j.fatti || 0), 0);
  const totale = running.reduce((s, j) => s + (j.totale || 0), 0);

  return (
    <div data-testid="extraction-indicator"
      className="fixed bottom-4 left-4 z-[90] bg-white border border-[#C9A84C]/60 shadow-lg rounded-sm px-4 py-2.5 text-sm text-[#1A2B4A] flex items-center gap-2.5">
      {running.length > 0 ? (
        <>
          <Loader2 className="w-4 h-4 animate-spin text-[#C9A84C]" />
          <span data-testid="extraction-indicator-progress">Lettura documenti… {fatti} di {totale}</span>
        </>
      ) : (
        <>
          <ScanLine className="w-4 h-4 text-[#276749]" />
          <span data-testid="extraction-indicator-ready">Lettura completata: riapri la scheda per applicare i dati</span>
        </>
      )}
    </div>
  );
}
